
import { SpecialEvent } from '../../types/specialEvent';
import { skills } from '../skills';

export const regulatoryShiftEvent: SpecialEvent = {
  id: 'regulatory-shift',
  title: 'Regulatory Paradigm Shift',
  description: 'Government regulations around cryptocurrency mining are changing. How will your operation respond?',
  type: 'regulatory',
  triggerYears: [2, 7, 13], // Regulatory changes can happen at various points
  options: [
    {
      text: 'Comply fully with new regulations',
      outcome: 'You implement all required changes to stay fully compliant.',
      roleSpecificOutcome: [
        {
          roleId: 'operations',
          outcome: 'Your operations background allows you to implement compliance measures with minimal disruption.',
          kpiEffects: {
            uptime: 1,
            profitMargin: -1
          },
          experienceGain: 25
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'regulatory-compliance',
          outcome: 'Your regulatory compliance expertise helps you navigate the changes efficiently.',
          kpiEffects: {
            uptime: 2,
            efficiency: 1
          },
          experienceGain: 30
        }
      ],
      kpiEffects: {
        uptime: -2,
        profitMargin: -3,
        efficiency: -1
      },
      experienceGain: 15,
      skillUnlock: skills.find(s => s.id === 'regulatory-compliance')
    },
    {
      text: 'Relocate operations to a friendlier jurisdiction',
      outcome: 'You move your mining operations to an area with more favorable regulations.',
      roleSpecificOutcome: [
        {
          roleId: 'entrepreneur',
          outcome: 'Your entrepreneurial network helps you find the optimal location with excellent infrastructure and incentives.',
          kpiEffects: {
            energyCost: -0.005,
            profitMargin: 3
          },
          experienceGain: 35
        },
        {
          roleId: 'energy',
          outcome: 'Your energy expertise helps you select a location with optimal power conditions.',
          kpiEffects: {
            energyCost: -0.008,
            efficiency: 2
          },
          experienceGain: 30
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'strategic-planning',
          outcome: 'Your strategic planning skills result in a seamless transition with minimal downtime.',
          kpiEffects: {
            uptime: 2,
            profitMargin: 2
          },
          experienceGain: 30
        }
      ],
      kpiEffects: {
        uptime: -5,
        profitMargin: -2,
        energyCost: -0.003
      },
      experienceGain: 25
    },
    {
      text: 'Engage in industry advocacy',
      outcome: 'You join forces with other miners to influence regulatory direction.',
      roleSpecificOutcome: [
        {
          roleId: 'entrepreneur',
          outcome: 'Your business connections amplify your advocacy efforts, generating significant industry support.',
          kpiEffects: {
            profitMargin: 3,
            uptime: 1
          },
          experienceGain: 40
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'industry-influence',
          outcome: 'Your industry influence results in regulatory compromises that benefit mining operations.',
          kpiEffects: {
            profitMargin: 5,
            uptime: 2
          },
          experienceGain: 45
        },
        {
          skillId: 'negotiation',
          outcome: 'Your negotiation skills help secure favorable terms in the new regulatory framework.',
          kpiEffects: {
            profitMargin: 3,
            efficiency: 2
          },
          experienceGain: 35
        }
      ],
      kpiEffects: {
        profitMargin: 0,
        efficiency: 0,
        uptime: 0
      },
      experienceGain: 20,
      skillUnlock: skills.find(s => s.id === 'negotiation')
    }
  ]
};
